<template>
    <div>
        <v-row class="mt-2" v-if="groupe == 'VISITE DU SITE D\'EMBOUTEILLAGE DU CHANCET'">
            <v-col md="4" cols="12">
                <img class="descriptionGroupImage" :src="usineImage" alt="">
            </v-col>
            <v-col md="8" cols="12" class="d-flex flex-column">

                <div> Explorez les coulisses de notre usine pour comprendre le processus d'embouteillage de Volvic.
                </div>
                <div class="mt-3 mb-2 text-uppercase"><b>Infos pratiques :</b></div>
                <div class="mb-2"><v-icon icon="mdi-square-small" color="primary-dark"></v-icon>Adresse : Usine du
                    Chancet - Se garer
                    au parking P2 (gratuit) puis suivre fléchage</div>
                <div class="mb-2"><v-icon icon="mdi-square-small" color="primary-dark"></v-icon>Sʼagissant dʼun site
                    industriel, par
                    mesure de sécurité et d'hygiène, nous vous prions dʼéviter les bijoux,
                    montres, chaussures à talons, vernis et de privilégier le port de pantalon et de chaussures fermées.
                    Lʼéquipement nécessaire pour la visite sera fourni sur place.</div>
                <div class="mb-2"><v-icon icon="mdi-square-small" color="primary-dark"></v-icon>Pour des raisons de
                    sécurité, les enfants de moins de 7 ans ne sont pas admis (une pièce d'identité
                    peut être demandée). La visite est réservée aux personnes capables de se déplacer sans difficulté,
                    avec un rythme de marche soutenu.
                </div>
                <div class="mb-2"><v-icon icon="mdi-square-small" color="primary-dark"></v-icon>Fermeture des
                    inscriptions le 13/05
                </div>
                <div class="mb-2">L'usine de Volvic se réserve le droit d'annuler les visites en cas d'aléa</div>
            </v-col>
        </v-row>
        <v-row class="mt-2" v-if="groupe == 'VISITE DE L\'IMPLUVIUM DE VOLVIC'">
            <v-col md="4" cols="12">
                <img class="descriptionGroupImage" :src="impluviumImage" alt="">
            </v-col>
            <v-col md="8" cols="12" class="d-flex flex-column">

                <div> Partez à la découverte de l’impluvium de Volvic situé au cœur de la Chaîne des Puys d’Auvergne
                </div>
                <div class="mt-3 mb-2 text-uppercase"><b>Infos pratiques :</b></div>
                <div class="mb-2"><v-icon icon="mdi-square-small" color="primary-dark"></v-icon>Adresse : Volvic
                    O'rigines, rue des
                    Sources 63 530 VOLVIC (Parking gratuit)</div>
                <div class="mb-2"><v-icon icon="mdi-square-small" color="primary-dark"></v-icon>Service de navette
                    depuis le Parc de
                    la Source</div>
                <div class="mb-2"><v-icon icon="mdi-square-small" color="primary-dark"></v-icon>Fermeture des
                    inscriptions le 13/05
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import usineImage from '@/assets/img/usine_volvic_50.jpg'
import impluviumImage from '@/assets/img/impluvium_volvic_50.jpg'
export default {
    props: ["groupe"],
    data() {
        return {
            usineImage,
            impluviumImage

        }
    }
}
</script>

<style lang="scss" scoped>
.descriptionGroupImage {
    width: 100%;
    height: auto;
    border-radius: 3px;

}
</style>